import React, { useEffect } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "../features/cutomers/customerSlice";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Mobile",
    dataIndex: "phone",
  },
  {
    title: "Address",
    dataIndex: "address",
  },
  {
    title: "Bio",
    dataIndex: "bio",
  },
];

const Customers = () => {
  const dispatch = useDispatch();

  const customerstate = useSelector((state) => state.customer.customers);
  const isLoading = useSelector((state) => state.customer.isLoading);

  useEffect(() => {
    dispatch(getUsers());
  }, []);

  // const data1 = [];
  // for (let i = 0; i < customerstate.length; i++) {
  //   if (customerstate[i].role !== "admin") {
  //     data1.push({
  //       key: i + 1,
  //       // name: customerstate[i].firstname + " " + customerstate[i].lastname,
  //       name: customerstate[i].name,
  //       email: customerstate[i].email,
  //       phone: customerstate[i].phone,
  //       address: customerstate[i].address,
  //       bio: customerstate[i].bio,
  //     });
  //   }
  // }

  const data1 = customerstate?.length
  ? customerstate
      .filter((customer) => customer.role !== "admin")
      .map((customer, index) => ({
        key: index + 1,
        name: customer.name,
        email: customer.email,
        phone: customer.phone,
        address: customer.address,
        bio: customer.bio,
      }))
  : [];


  return (
    <div>
      <h3 className="mb-4 title">Customers</h3>
      {/* <div>
        <Table columns={columns} dataSource={data1} />
      </div> */}
            {isLoading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <Table columns={columns} dataSource={data1} />
        </div>
      )}
    </div>
  );
};

export default Customers;
